import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import AuthService from "./services/Auth";

export const PrivateRoute = props => {
    const user = AuthService.getCurrentUser();
    if (!user) return <Redirect to={`/login/?next=${encodeURIComponent(props.location.pathname)}`} />
    return <Route {...props} />
}
